<template>

    <div class="row footerPaneHorizontal">
        <div class="col-12">

            <div class="row footerPaneRowCombined">
                <div class="col-6">
                    <div class="footerTXOCBox">
                        <img class="footerTXOCLogo" alt="Oncourse logo" src="../assets/txocLogoHorizontal_white.svg">
                    </div>
                </div>
                <div class="col-6">
                    <div style="text-align:right;height:2em; padding: 0.2em 0 0 0;">
                        <div>
                            <a href="#" class="fa fa-facebook"></a>
                            <a href="#" class="fa fa-blog">blog</a>
                            <a href="#" class="fa fa-twitter"></a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row footerPaneRowStacked">
                <div class="col-12">
                    <div class="footerTXOCBox">
                        <img class="footerTXOCLogo" alt="Oncourse logo" src="../assets/txocLogoHorizontal_white.svg">
                    </div>
                    <div style="text-align:center;height:2em; padding: 0.2em 0 0 0;">
                        <div>
                            <a href="#" class="fa fa-facebook"></a>
                            <a href="#" class="fa fa-blog">blog</a>
                            <a href="#" class="fa fa-twitter"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'ltiFooter',
        data() {
            return {
                envVars: process.env,
                store: this.$store,
                footerQuestionHeader: "Can't find your school or major?"
            };
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--
<style scoped lang="scss" src="@/styles/footer.scss">
-->
<style scoped lang="scss">
    @import "../styles/footer";
</style>
